/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type CatalogUpdateCatalogRequest = {
  id: number;
  category: CatalogUpdateCatalogRequest.category;
  title?: string;
  sub_title?: string;
  page_count: number;
  image_id?: number;
  catalog_url?: string;
};

export namespace CatalogUpdateCatalogRequest {
  export enum category {
    SCIENCE = "science",
    HEALTH = "health",
    FACILITIES = "facilities",
  }
}
